import { render, staticRenderFns } from "./WrongAnalysisIndex.vue?vue&type=template&id=e43e5156&scoped=true"
import script from "./WrongAnalysisIndex.vue?vue&type=script&lang=js"
export * from "./WrongAnalysisIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43e5156",
  null
  
)

export default component.exports